import React from "react";
import WarmupProjetosCountCard from "./Components/WarmupProjetosCountCard";

const DashboardProjetos = () => {
    return (
        <div className="flex">
            <div className="flex gap-3 m-5">
                <WarmupProjetosCountCard />
                <WarmupProjetosCountCard />
                <WarmupProjetosCountCard />
                <WarmupProjetosCountCard />
            </div>
        </div>
    )
}

export default DashboardProjetos